import { makeStyles, Tooltip } from '@material-ui/core';
import { fontGrey, poppins, white } from '../../../styles/variables';
import React, { memo, ReactElement, ReactNode, useMemo } from 'react';
import { Content } from './index';
import { GAME, renderGameType } from '../../../constants/types';

const useStyles = makeStyles({
	root: {
		display: 'flex',
		flexDirection: 'column',
		alignItems: 'center',
		padding: '1rem'
	},
	tooltipRoot: {
		padding: 0,
		width: '400px',
		wordWrap: 'break-word',
		backgroundColor: white,
		boxShadow: '0 10px 20px 0 rgba(0, 0, 0, 0.24)'
	},
	popper: {
		whiteSpace: 'pre-line'
	},
	arrow: {
		color: white
	},
	game: {
		height: '1.25rem',
		fontFamily: poppins,
		fontSize: '1rem',
		letterSpacing: '0.6px',
		color: fontGrey
	}
});

interface IProps {
	children: ReactNode;
	message: string;
	gameType: string;
}

const PoiTooltip: React.FunctionComponent<IProps> = ({
	children,
	message,
	gameType
}): ReactElement => {
	const classes = useStyles();

	const tooltipContent = useMemo(() => {
		return (
			<div className={classes.root}>
				<Content text={message} />
				<div className={classes.game}>{renderGameType(gameType as GAME)}</div>;
			</div>
		);
	}, [classes, message, gameType]);

	return (
		<Tooltip
			title={tooltipContent}
			arrow
			enterDelay={200}
			placement={'top'}
			interactive
			classes={{
				tooltip: classes.tooltipRoot,
				popper: classes.popper,
				arrow: classes.arrow
			}}
		>
			<div>{children}</div>
		</Tooltip>
	);
};

export default memo(PoiTooltip);
